import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=d4bedca4&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4bedca4')) {
      api.createRecord('d4bedca4', component.options)
    } else {
      api.reload('d4bedca4', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=d4bedca4&", function () {
      api.rerender('d4bedca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sp4zTBcYbPV3/JS/comp/seasonprices.vue"
export default component.exports